<template>
  <NuxtLayout class="NuxtLayout min100vh mounted">
    <Page404 :content="page.data" :error="error" />
  </NuxtLayout>
</template>

<script setup lang="ts">
import { setWindowSize } from "~/plugins/functions/vhCheck";

const error = useError();
const mounted = ref(false);

const store = useLayoutStore();

const prismic = usePrismic();
// const translatesStore = useTranslatesStore();
// await useAsyncData("All_Translations", async () => {
//   return await translatesStore.GET_All_Translations(false, prismic);
// });

const {
  data: { value: page },
} = await useAsyncData("page-404", () => prismic.client.getSingle("404"));

// get navigation
const getNavigation = async () => {
  const navigation = await prismic.client.getSingle("navigation", {});
  if (navigation?.data?.list) {
    store.SET_Navigation(navigation.data.list);
    return navigation.data.list;
  }
  return null;
};
useAsyncData("navigation", getNavigation);

const resize = () => {
  setWindowSize();
  store.setDocScreenSize();
};

if (import.meta.client) setWindowSize();
onMounted(() => {
  setWindowSize();
  store.setDocScreenSize();
  window.addEventListener("resize", resize);
  requestAnimationFrame(() => {
    mounted.value = true;
  });
});
onUnmounted(() => window.removeEventListener("resize", resize));
</script>

<style scoped></style>
